import { DestructiveDialog, DestructiveDialogProps } from './DestructiveDialog';
import { DestructiveDialogResult } from './types';
import { makeDialog } from '../../makeDialog';

export const useDestructiveDialog = makeDialog<
  DestructiveDialogProps,
  DestructiveDialogResult
>(DestructiveDialog);
